import SharedLayout from './SharedLayout'

export default SharedLayout;